export interface Permission {
	id: number;
	coreFeatures: boolean;
	manageSiteUsers: boolean;
	siteBusinessDays: boolean;
	manageSites: boolean;
	transferWithinOrg: boolean;
	replenishment: boolean;
	transferOutsideOfOrg: boolean;
	manageOrgUsers: boolean;
	deactivateSites: boolean;
	viewAllSitesForOrg: boolean;
	viewAllSites: boolean;
	deactivateOrgs: boolean;
	reports: boolean;
	manageOrganizations: boolean;
	viewQuartzJobs: boolean;
	adminFeatures: boolean;
	permissionProfile?: any;
}

export class PermissionConst {
	public static coreFeatures = "coreFeatures";
	public static manageSiteUsers = "manageSiteUsers";
	public static siteBusinessDays = "siteBusinessDays";
	public static manageSites = "manageSites";
	public static transferWithinOrg = "transferWithinOrg";
	public static replenishment = "replenishment";
	public static transferOutsideOfOrg = "transferOutsideOfOrg";
	public static manageOrgUsers = "manageOrgUsers";
	public static deactivateSites = "deactivateSites";
	public static viewAllSitesForOrg = "viewAllSitesForOrg";
	public static viewAllSites = "viewAllSites";
	public static deactivateOrgs = "deactivateOrgs";
	public static reports = "reports";
	public static manageOrganizations = "manageOrganizations";
	public static viewQuartzJobs = "viewQuartzJobs";
	public static adminFeatures = "adminFeatures";
}
